//Gnav
$(function() {
  var timer = false;
  $(window).resize(function() {
    var windowWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      if (windowWidth > 768) {
        $('.toggle__hamburger')
          .removeClass('toggle__hamburger-active')
          .next('nav')
          .find('ul')
          .removeAttr('style');
        $('.toggle__language')
          .removeClass('toggle__language-active')
          .next('nav')
          .find('ul')
          .removeAttr('style');
        $('.nav')
          .removeClass('nav-active')
          .removeAttr('style');
        $('body')
          .removeClass('body-active')
          .removeAttr('style');
      } else {
        $('.language').removeAttr('style');
      }
    }, 100);
  });

  var toggleItem = $('.toggle__item'),
    nav = $('.nav'),
    scrollOff = function (e) {
      e.preventDefault();
    };


  toggleItem.on('click', function() {
    var windowWidth = window.innerWidth;
    if (windowWidth < 768) {
      var index = $(toggleItem).index(this),
        useClass = function() {
          nav.removeClass('nav-active');
          nav.eq(index).addClass('nav-active');
        };
      if (
        $(this)
          .parents('.header')
          .find('.nav')
          .eq(index)
          .hasClass('nav-active')
      ) {
        $('body').removeClass('body-active');
        $(this)
          .parents('.header')
          .find('.nav')
          .eq(index)
          .removeClass('nav-active');
        toggleItem.removeClass('toggle__language-active');
        toggleItem.removeClass('toggle__hamburger-active');
        document.removeEventListener('touchmove', scrollOff, { passive: true });
      } else if (index === 0) {
        $('.toggle__language').removeClass('toggle__language-active');
        $('.toggle__hamburger').addClass('toggle__hamburger-active');
        useClass();
        $('body').addClass('body-active');
        document.addEventListener('touchmove', scrollOff, { passive: false });
      } else if (index === 1) {
        $('.toggle__hamburger').removeClass('toggle__hamburger-active');
        $('.toggle__language').addClass('toggle__language-active');
        useClass();
        $('body').addClass('body-active');
        document.addEventListener('touchmove', scrollOff, { passive: false });
      }
    }
  });

  $('.nav__item a,.is-close').on('click', function() {
    var windowWidth = window.innerWidth;
    if (windowWidth < 768) {
      toggleItem.removeClass('toggle__language-active');
      toggleItem.removeClass('toggle__hamburger-active');
      nav.removeClass('nav-active');
      $('body').removeClass('body-active');
      document.removeEventListener('touchmove', scrollOff, { passive: true });
    }
  });

  $('.is-snav__item').on('click', function() {
    $(this)
      .find('.language')
      .stop(true, true)
      .slideToggle();
  });
  $('.is-language__title').on('click', function () {
    $(this)
      .next('.language__list')
      .stop(true, true)
      .slideToggle();
  });
});

//responsiveBg
function responsiveBg() {
  var VisualH = function(h) {
    var whsp = $(window).height() - h;
    $('.is-photo').css('height', whsp + 'px');
  };
  var ww = $(window).width();
  if (ww <= 768) {
    VisualH(65);
  } else {
    VisualH(125);
  }
}

$(function() {
  responsiveBg();
  $(window).on({
    resize: function() {
      responsiveBg();
    }
  });
  $(window).on({
    load: function() {
      responsiveBg();
    }
  });
});

//tel
var ua = navigator.userAgent.toLowerCase();
var isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

if (!isMobile) {
  $('a[href^="tel:"]').on('click', function(e) {
    e.preventDefault();
  });
}

// Scroll
$(function() {
  $('.is-scroll').click(function() {
    var speed = 800;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top + 'px';
    $('html, body').animate(
      {
        scrollTop: position
      },
      speed
    );
    return false;
  });
});
